module.exports = __webpack_public_path__ + "img/textatatamaru.9e9a4f0a.svg";